import React from "react";

export const SectionHeader = ({ title, subtitle, action, className = "" }) => {
  return (
    <div data-testid="section-header" className={`flex items-end justify-between gap-4 ${className}`}>
      <div>
        <h1 className="font-display text-3xl sm:text-4xl tracking-[-0.02em] text-foreground">{title}</h1>
        {subtitle && <p className="mt-1.5 text-sm md:text-base text-muted-foreground max-w-2xl">{subtitle}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
};
